import React, { useState } from "react";
import { Card, Row, Steps, Button, Popover } from "antd";
import { useNavigate } from "react-router-dom";
// import vimeo from "../../../assets/images/sajanaThumbnail.png";
import vimeo from "../../../assets/images/sajana-photo.jpg";
import { useAppSelector } from "../../../hooks/reduxHooks";
import reviseImg from "../../../assets/images/icons/revise.png";
import ReactGA from "react-ga4";
import { IoInformationCircle, IoClose } from "react-icons/io5";

interface ReviseSkincareComponentInterface {}
const ReviseSkincareComponent: React.FC<
  ReviseSkincareComponentInterface
> = () => {
  const state = useAppSelector((state) => state);
  const { userData }: { userData?: any } = state.profile;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const getCurrentStep = () => {
    let currentStep = 0;
    switch (userData?.survey_status) {
      case "draft":
        currentStep = 0;
        break;

      case "paid":
        currentStep = 2;
        break;

      case "answered":
        currentStep = 1;
        break;

      case "responded":
        currentStep = 3;
        break;

      default:
        currentStep = 1;
    }
    return currentStep;
  };

  const getContinueButton = (upcomingStatus?: string) => {
    switch (userData?.survey_status) {
      case "draft":
        return (
          <>
            <Button
              size="small"
              type="primary"
              className="stepper-btn"
              onClick={() => {
                ReactGA.event({
                  category: "Store",
                  action: `Revise Skincare Timeline CTA Button Click`,
                  label: "Go to Payment",
                  nonInteraction: true, // optional, true/false
                  transport: "xhr",
                });
                navigate("/payment");
              }}
            >
              <span>Continue</span>
            </Button>
          </>
        );

      case "paid":
        return (
          <>
            <Button
              size="small"
              type="primary"
              className="stepper-btn"
              onClick={() => {
                ReactGA.event({
                  category: "Store",
                  action: `Revise Skincare Timeline CTA Button Click`,
                  label: "Go to quiz",
                  nonInteraction: true, // optional, true/false
                  transport: "xhr",
                });
                navigate("/skincaresteps");
              }}
            >
              <span>Continue</span>
            </Button>
          </>
        );

      default:
        return <></>;
    }
  };

  return (
    <Row className="skin-profile__contact">
      {userData?.survey_status !== "responded" &&
      userData?.survey_status !== "draft" &&
      userData?.has_store &&
      userData?.can_revise ? (
        <Card bordered={false} className="skin-profile__contact__stepper">
          <h1 className="section-title">Revise Skincare</h1>
          <span>Requested Skincare Revision progress</span>
          <div className="skin-profile__contact__stepper__div">
            <Steps
              className="skin-profile__contact__stepper__div__step"
              size="small"
              current={getCurrentStep()}
              labelPlacement="vertical"
              responsive
              items={[
                {
                  title: "Answered Quiz",
                  description:
                    userData?.survey_status === "draft" ? (
                      getContinueButton("toAnswer")
                    ) : (
                      <></>
                    ),
                },
                {
                  title: "Payment Completed",
                  description:
                    userData?.survey_status === "draft" ? (
                      getContinueButton("toAnswer")
                    ) : (
                      <></>
                    ),
                },
                {
                  title: "Waiting Response",
                },
                {
                  title: "Space Ready",
                },
              ]}
            />
          </div>
        </Card>
      ) : userData?.can_revise ? (
        <div
          className="skin-profile__contact__revise"
          onClick={() => {
            navigate("/skincaresteps");
            ReactGA.event({
              category: "Store",
              action: `Revise Skincare Card Click`,
              label: "Go to Payment",
              nonInteraction: true, // optional, true/false
              transport: "xhr",
            });
          }}
        >
          <img src={reviseImg} alt="revise-img" />
          <div className="revise-wrapper">
            <p>Revise Your Skincare</p>
            <Popover
              open={open}
              onOpenChange={(val?: any) => {
                setOpen(val);
              }}
              overlayClassName="popover revise-popover"
              content={
                <>
                  <div
                    className="popover__close"
                    onClick={(e?: any) => {
                      e.stopPropagation();
                      setOpen(false);
                    }}
                  >
                    <IoClose />
                  </div>
                  <div className="popover__content">
                    We recommend to revise your skincare every 90 days. That's 3
                    months time. As we move into new season, your skin may need
                    different product. Plus you may have a new skincare goals
                    now. Click revise your skincare and fill out the good old
                    quiz to your skincare. We are always here to keep your skin
                    up to date!
                  </div>
                </>
              }
              trigger="click"
            >
              <div
                className="popover__clickable"
                onClick={(e?: any) => {
                  e.stopPropagation();
                }}
              >
                <IoInformationCircle className="icon" color="#6489b1" />
              </div>
            </Popover>
          </div>
        </div>
      ) : (
        <Card
          bordered={false}
          className="skin-profile__contact__contactSection"
        >
          <h1 className="section-title">Have any question?</h1>
          <div className="skin-profile__contact__contactSection__section">
            <h3>Ask our human skincare expert</h3>
            <img
              className="skin-profile__contact__contactSection__section__image"
              src={vimeo}
              alt=""
              width={80}
              height={80}
              style={{
                objectFit: "cover",
                objectPosition: "top center",
              }}
            />
            <a
              href="mailto:expert@missingskincare.com"
              onClick={() => {
                ReactGA.event({
                  category: "Store",
                  action: `Contact email clicked`,
                  label: "Contact email on store dashboard",
                  nonInteraction: true, // optional, true/false
                  transport: "xhr",
                });
              }}
            >
              <h3>expert@missingskincare.com</h3>
            </a>
          </div>
        </Card>
      )}
    </Row>
  );
};
export default ReviseSkincareComponent;
